//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import styled, { css } from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import { CaptionSecondaryText, TitleText } from '@components/atoms/text/Text';
import bazaarvoiceLogo from '@images/bv-logo-white.svg';
import bvTextLogo from '@images/bv-text.svg';
import coverBackground from '@images/reports/cover_background.png';

// Cover Pages
const CoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  height: 816px;
  width: 100%;
  background-image: url(${coverBackground});
  background-size: cover;
  color: #ffffff;
  overflow: hidden;
`;

export const ReportCoverContainer = styled(CoverContainer)`
  padding: 70px 110px 60px;
`;

export const ReportSectionCoverContainer = styled(CoverContainer)`
  padding: 70px 20px 20px 110px;
`;

export const BazaarvoiceLogo = styled.img.attrs({
  alt: 'Bazaarvoice Logo',
  src: bazaarvoiceLogo,
})`
  width: 100px;
`;

export const Rectangle = styled.div`
  height: 8px;
  width: 80px;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgba(202, 163, 232, 0.3);
`;

export const Container = styled.div(
  () => `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    height: 816px;
    width: 100%;
    padding: 20px;
    page-break-after: always;

    // We don't want any clickable event on the PDF
    button, a {
      pointer-events: none !important;
    }
  `,
);

export const GlossaryContainer = styled(Container)(
  () => `
    break-after: avoid;
    page-break-after: avoid;
  `,
);

export const Date = styled(CaptionSecondaryText)(
  () => `
    position: absolute;
    top: 20px;
    right: 20px;
  `,
);

export const HeaderWrapper = styled.div`
  margin-top: 40px;
  padding: 0 20px;
`;

export const Title = TitleText;

export const Description = styled.div(
  ({ theme }) => `
    margin-top: ${theme.spacings[2]};
    color: ${theme.colors.gray7};
    font-size: ${theme.fontSizes[5]};
    line-height: ${theme.lineHeights.bodyLeading};
  `,
);

export const ContentContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 0 20px;
`;

export const RowContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
  padding: 0 20px;
`;

export const Disclaimer = styled.div(
  ({ theme }) => `
    display: flex;
    margin-top: 10px;
    padding: 0 20px;
    font-family: sofia-pro;
    font-size: ${theme.fontSizes[6]};
    font-style: italic;
  `,
);

export const Footer = styled.div(
  () => `
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
  `,
);

export const FooterContainer = styled.div(
  ({ theme }) => `
    margin-top: ${theme.spacings[3]};
  `,
);

export const PageNumber = CaptionSecondaryText;

export const Logo = styled.img.attrs({
  alt: 'Bazaarvoice Logo',
  src: bvTextLogo,
})`
  height: 10px;
`;

export const LightbulbIcon = styled(Icon).attrs({
  name: 'lightbulb',
})(
  ({ theme }) => `
    margin-right: ${theme.spacings[2]};
    color: ${theme.colors.aliases.primary};
  `,
);

/**
 * This is needed to work around the quirk with rendering box-shadows
 * On the Preview app and some PDF readers box-shadows are rendering as thick borders
 *
 */
export const mediaOrDataCardMixin = css`
  margin: 0 ${theme.spacings[2]};
  filter: drop-shadow(0 1px 3px rgb(0 0 0 / 24%));
`;

export const STANDARD_CHART_HEIGHT = 500;
export const STANDARD_CHART_WIDTH = 950;
